import { ButtonIconSizes, IconPositions } from 'atoms/Button'
import { SecondaryButton } from 'atoms/Button/Templates'
import { Icon, IconNames } from 'atoms/Icon'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { TextBlock } from 'blocks/TextBlock'
import { FIXED_INDENTS } from 'vars/index'
import {
  ErrorDescriptionSC,
  ErrorDescriptionWrapper,
} from './ErrorDescription.styled'

export interface IErrorDescriptionProps {
  error?: string
  from?: string
  title?: string
  handleButtonClick?: () => void
  buttonTitle?: string
  buttonIcon?: IconNames
}

export const ErrorDescription = ({
  title = 'Error',
  from,
  error,
  handleButtonClick,
  buttonTitle,
  buttonIcon,
}: IErrorDescriptionProps) => {
  return (
    <ErrorDescriptionWrapper>
      <Icon name={IconNames.ghost404} />
      <ErrorDescriptionSC>
        <TextBox
          title={title}
          color={TextBoxColors.TEXT_ICON_CONSTANT_LIGHT}
          font={TextBoxTypes.HeadlineExtra10}
        />
        <TextBlock>
          <TextBox verticalGap={FIXED_INDENTS.INDENT_20}>
            <>
              {Boolean(from) && (
                <>
                  <TextBox
                    title={`You were about to open `}
                    color={TextBoxColors.TEXT_ICON_PRIMARY}
                    font={TextBoxTypes.Body1}
                  />
                  <TextBox
                    title={from}
                    color={TextBoxColors.TEXT_ICON_PRIMARY}
                    font={TextBoxTypes.Body1}
                  />
                </>
              )}
            </>
            <TextBox
              title={from ? 'but error happend.' : 'Error happend.'}
              color={TextBoxColors.TEXT_ICON_PRIMARY}
              font={TextBoxTypes.Body1}
            />
          </TextBox>
          {error && (
            <TextBlock>
              <TextBox
                title={String(error)}
                color={TextBoxColors.TEXT_ICON_TERTIARY}
                font={TextBoxTypes.Body3}
              />
            </TextBlock>
          )}
        </TextBlock>
        <SecondaryButton
          paddings={[FIXED_INDENTS.INDENT_10, FIXED_INDENTS.INDENT_80]}
          title={buttonTitle}
          icon={buttonIcon ? IconNames[buttonIcon] : undefined}
          iconSize={ButtonIconSizes.small}
          iconPosition={IconPositions.Left}
          onClick={handleButtonClick}
        />
      </ErrorDescriptionSC>
    </ErrorDescriptionWrapper>
  )
}
